// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.46.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div#main-layout[data-v-792bf8b0]{background:#eee}a#home-link[data-v-792bf8b0],a.v-btn[data-v-792bf8b0]{text-decoration:none}", ""]);
// Exports
module.exports = exports;
